export const TagType = {
  counterOffer: 'counter_offer',
  origin: 'origin',
};

export const TagContent = {
  counterOffer: 'counter_offer',
  origin: 'origin',
};
